import React from 'react';

import { PhysicalComponentVisual, ThreeJsScene } from '@paragon/three-js-truss-scene';

import { getTrussesForStackedTrussPreview } from '../../../selectors/stackedTrussPreview';
import { useAppSelector } from '../../hooks';

interface Props {
  componentPreviewWidth: number;
  componentPreviewHeight: number;
}

export function StackedTrussPreview(props: Props) {
  const trussesForPreview = useAppSelector(getTrussesForStackedTrussPreview);

  return (
    <ThreeJsScene width={props.componentPreviewWidth} height={props.componentPreviewHeight}>
      {Object.entries(trussesForPreview).map(([key, { truss, matrix }]) => (
        <PhysicalComponentVisual
          key={key}
          matrix={matrix}
          members={truss.members}
          component={truss}
          showComponentLabel={false}
        />
      ))}
    </ThreeJsScene>
  );
}
